import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { HeadphonesOutlined, VisibilityOutlined } from "@mui/icons-material";
import { useIsMobile } from "../../hooks/responsive";

const PodcastVideoItem = ({
  item,
  onClickWatch,
  onClickListen,
  selected = false,
  variant = "row",
  canListen = true,
  ...props
}) => {
  const isMobile = useIsMobile();
  const direction = React.useMemo(() => {
    return isMobile ? "column" : variant;
  }, [isMobile, variant]);

  const variantModifier = React.useMemo(() => {
    return direction === "column" ? 1 : 0;
  }, [direction]);

  return (
    <Grid
      container
      {...props}
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        backgroundColor: selected ? "#ffffff22" : undefined,
        padding: 1,
        borderRadius: "15px",
        ...props.sx,
      }}
      spacing={2}
    >
      <Grid
        item
        size={{
          xs: 3 + variantModifier,
          md: 3 + variantModifier,
          lg: 2 + variantModifier,
        }}
      >
        <Box
          sx={{
            width: "100%",
            aspectRatio: 156 / 82,
          }}
        >
          <img
            src={item.image}
            alt={"podcast image"}
            style={{
              width: "100%",
              aspectRatio: 156 / 82,
              objectFit: "cover",
            }}
          />
        </Box>
      </Grid>
      <Grid
        item
        size={{
          xs: 8 - variantModifier,
          md: 9 - variantModifier,
          lg: 10 - variantModifier,
        }}
        sx={{
          display: "flex",
          flexDirection: direction,
          justifyContent: "space-between",
          alignItems: direction === "row" ? "center" : "flex-start",
        }}
      >
        <Typography>{item.titre}</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexDirection: "row",
          }}
        >
          <Button
            onClick={onClickWatch}
            sx={{
              display: "flex",
              alignItems: "center",
              textTransform: "none",
              borderRadius: "5px",
            }}
          >
            <VisibilityOutlined
              sx={{
                marginRight: "10px",
                marginTop: 0.5,
                marginBottom: 0.5,
              }}
            />
            <Typography
              sx={{
                fontSize: "800",
                height: "100%",
                verticalAlign: "center",
              }}
            >
              Regarder
            </Typography>
          </Button>
          {canListen && (
            <Button
              onClick={onClickListen}
              sx={{
                display: "flex",
                alignItems: "center",
                textTransform: "none",
                borderRadius: "5px",
              }}
            >
              <HeadphonesOutlined
                sx={{
                  marginRight: "10px",
                  marginTop: 0.5,
                  marginBottom: 0.5,
                }}
              />
              <Typography
                sx={{
                  fontSize: "800",
                  height: "100%",
                  verticalAlign: "center",
                }}
              >
                Écouter
              </Typography>
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PodcastVideoItem;
